module.exports = __webpack_public_path__ + "static/media/personality_theme_preview_2.f8d281e3.jpg";